export { default } from "./Main";



// WEBPACK FOOTER //
// ./src/components/Main/index.js